import React,{ Fragment, useContext} from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import { ViewerContext } from "../../context/ViewerContext";

export default function Layer() {
    const { showLegal, setShowLegal} = useContext(ViewerContext);


    return (
        <Transition.Root show={showLegal} as={Fragment}>
            <Dialog className="relative z-10" onClose={setShowLegal}>
                <div className="fixed inset-0" />

                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 z-50 right-0 flex max-w-full pl-10 sm:pl-16  mt-[59px] lg:mt-[0px]  sideOver ">
                            <Transition.Child
                                as={Fragment}
                                enter="transform transition ease-in-out duration-500 sm:duration-700"
                                enterFrom="translate-x-full"
                                enterTo="translate-x-0"
                                leave="transform transition ease-in-out duration-500 sm:duration-700"
                                leaveFrom="translate-x-0"
                                leaveTo="translate-x-full"
                            >
                                <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                                    <div className="flex h-full flex-col overflow-y-scroll bg-white px-2 py-14 shadow-xl">
                                        <div className="px-4">
                                            <div className="flex items-start justify-between">
                                                <Dialog.Title className="text-xl px-2 mb-6 font-semibold leading-6 text-gray-900">
                                                   Quellenangaben und Nutzungsbedingungen
                                                </Dialog.Title>
                                                <div className="ml-3 flex h-7 items-center">
                                                    <button
                                                        type="button"
                                                        className="relative rounded-md bg-white text-gray-900 hover:text-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
                                                        onClick={() => setShowLegal(false)}
                                                    >
                                                        <span className="absolute -inset-2.5" />
                                                        <span className="sr-only">Close panel</span>
                                                        <XMarkIcon className="h-9 w-9" aria-hidden="true" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="relative mt-6 text-gray-600 flex-1 px-4 sm:px-6">
                                            <b>Wichtige Informationen zu den dargestellten Daten, Quellenangaben und Nutzungsbedingungen:</b><br/><br/>
                                            Die innerhalb unserer Open-Gov-Daten gepeicherten Daten sind hochwertige Daten im Sinne des § 10 Abs.  DNG und diese sind stets unentgeltlich unter einer Creative Commons BY 4.0 Lizenz oder weniger einschränkenden Lizenzen durch den Bund oder die Länder und Kommunen zur Verfügung zu stellen.<br/><br/>
                                            Dies gilt auch dann, wenn Geodaten der Länder mit einschränkenden Nutzungsbedingungen betroffen sind, weil sich das Bundesrecht und das Europarecht insoweit gegenüber dem Landesrecht durchsetzen.<br/><br/>
                                            Die betreffenden durch uns bezogenen Daten sind Datenkategorien vom Anhang 1 der Durchführungsverordnung (EU) 2023/138 vom 21.12.2022 und damit ist in der Regel eine kommerzielle Nutzung der Daten unentgeltlich unter Beachtung der zugrundeliegenden Nutzungsbedingungen zulässig.<br/><br/>
                                            Dies vorausgeschickt gelten für die durch uns als Open-Gov-Datensätze interoperabel-darstellend veredelten Datensätze und unter unserem Portal zur Verfügung gestellten Daten nun unsere Nutzungsbedingungen. Demnach hier bereitgestellte Daten dienen ausschließich der Information und besitzen keine Rechtsverbindlichkeit.<br/>

                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
